const scrollPageToBottom = (behavior: ScrollBehavior = 'instant') => window.scrollTo({
  top: document.body.scrollHeight,
  behavior,
});

export default scrollPageToBottom;
